import { gql } from '@apollo/client';

export const GET_SMART_FORM_DEFINITION_TEMPLATE = gql`
  query GetSmartFormDefinitionTemplate($uid: String!, $version: Int) {
    smartFormDefinition(uid: $uid, version: $version) {
      template
      status
    }
  }
`;
